var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChemicals = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "-200 -200 1200 1200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m951.7 852.2-326.9-506V91.7h41.6c22.7 0 41.6-18.5 41.6-40.8s-18.8-40.8-41.6-40.8H333.6C310.9 10 292 28.5 292 50.8s18.8 40.8 41.6 40.8h41.6v254.6l-326.9 506C-.4 928.1 34 990 125.6 990h748.7c91.7 0 126.1-61.9 77.4-137.8"
})));
export default SvgChemicals;